<!-- Title -->
@if ((translation().title | isBlank) === false) {
  @if (isNotificationTitle() && showTitle()) {
    <h2 class="d-flex flex-column">
      <span>{{ translation().title }}</span>
    </h2>
  } @else {
    <h3>{{ translation().title }}</h3>
  }
}

<!-- Content -->
@if (translation().content || translation().media) {
  <portal-rich-text
    [content]="translation().content"
    [media]="showImage() ? translation().media : undefined"
  ></portal-rich-text>
}
